/**
 * No-op useAlternates hook.
 * Actual SEO alternates are rendered as native <link> tags (React 19 metadata hoisting).
 */
export function useAlternates(): Record<string, string> | null {
  return null;
}
